import {
    Article as PriceEngineArticle,
    ConsumablePricingItem as PriceEngineConsumablePricingItem,
    DeviceConsumablePricingItem as PriceEngineDeviceConsumablePricingItem,
    DeviceConsumableWithSuppPricingItem as PriceEngineDeviceConsumableWithSuppPricingItem,
    DevicePricingItem as PriceEngineDevicePricingItem,
    OptionPricingItem as PriceEngineOptionPricingItem,
    PackPricingItem as PriceEnginePackPricingItem,
    ProductPricing as PriceEngineProductPricing,
    QuoteService as QuoteEngineQuoteService 
} from 'quote-domain-core';

export class PriceEnginePrototypeMapper {

    static setPricingItemPrototypes(quoteService: QuoteEngineQuoteService): void {
        quoteService.customGroups?.forEach(cg => {
            cg.pricingItems?.forEach((pi, idx, arr) => {
                switch (pi.pricingItemType) {
                    case 'DEVICE': {
                        arr[idx] = Object.setPrototypeOf(pi, PriceEngineDevicePricingItem.prototype);
                        PriceEnginePrototypeMapper.setArticlePrototype((pi as any).device);
                        break;
                    }
                    case 'PACK': {
                        arr[idx] = Object.setPrototypeOf(pi, PriceEnginePackPricingItem.prototype);
                        PriceEnginePrototypeMapper.setArticlePrototype((pi as any).device);
                        break;
                    }
                    case 'CONSUMABLE': {
                        arr[idx] = Object.setPrototypeOf(pi, PriceEngineConsumablePricingItem.prototype);
                        PriceEnginePrototypeMapper.setArticlePrototype((pi as any).consumable);
                        break;
                    }
                    case 'DEVICE_CONSUMABLE': {
                        arr[idx] = Object.setPrototypeOf(pi, PriceEngineDeviceConsumablePricingItem.prototype);
                        PriceEnginePrototypeMapper.setArticlePrototype((pi as any).device);
                        PriceEnginePrototypeMapper.setArticlePrototype((pi as any).consumable);
                        break;
                    }
                    case 'DEVICE_CONSUMABLE_WITH_SUPP': {
                        arr[idx] = Object.setPrototypeOf(pi, PriceEngineDeviceConsumableWithSuppPricingItem.prototype);
                        PriceEnginePrototypeMapper.setArticlePrototype((pi as any).device);
                        PriceEnginePrototypeMapper.setArticlePrototype((pi as any).consumable);
                        break;
                    }
                    case 'OPTION': {
                        arr[idx] = Object.setPrototypeOf(pi, PriceEngineOptionPricingItem.prototype);
                        PriceEnginePrototypeMapper.setArticlePrototype((pi as any).option);
                        break;
                    }
                }
            });
        });
    }

    private static setArticlePrototype(article: any): void {
        if (!article) return;
        Object.setPrototypeOf(article, PriceEngineArticle.prototype);
        article.productPricings?.forEach((pp: any) => {
            if (pp) {
                Object.setPrototypeOf(pp, PriceEngineProductPricing.prototype);
            }
        });
    }
}
